import { includes } from 'ramda';
import {hasValue} from "@amsanalytics/react-shared-library";

export const isImage = (mimeType: string) => mimeType?.startsWith("image/");
export const isVideo = (mimeType: string) => mimeType?.startsWith("video/");
export const isAudio = (mimeType: string) => mimeType?.startsWith("audio/");
export const isPdf = (mimeType: string) => mimeType === "application/pdf";
export const isText = (mimeType: string) => 
    mimeType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    || mimeType === "application/msword"
    || mimeType === "text/plain";

export const isSupportedDocument = (mimeType?: string) => {
  const result = 
    mimeType === 'image/bmp' ||
    mimeType === 'image/gif' ||
    mimeType === 'image/jpeg' ||
    mimeType === 'image/tiff' ||
    mimeType === 'image/png' ||
    mimeType === 'image/webp';
  return result;
}

// Returns true if the the given extension is supported for viewing in an iFrame.
export const isSupportedExtension = (extension?: string): boolean => {
  const supportedExtensions: string[] = ['.jpg', '.jpeg', '.png'];
  return hasValue(extension) && includes(extension?.toLowerCase(), supportedExtensions);
}
